/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import { FindingSuggestionsFilters } from './findingSuggestionsQueryParams';
import { useAppDispatch } from '../../../../core/store';
import { SelectItem } from '../../../../shared/ModalSelectField';
import { ModalMultiSelectField } from '../../../../shared/ModalMultiSelectField';
import { fetchCountries, selectCountries, selectIsFetchingCountries } from '../../store/findingSuggestionsSlice';

interface CountryMultiSelectFieldProps {
  filters: FindingSuggestionsFilters;
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (brand: string[]) => void;
}

export function CountryMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: CountryMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchCountries(filters));
    }
  }, [dispatch, editable, filters]);

  const items = useSelector(selectCountries);
  const isFetching = useSelector(selectIsFetchingCountries);

  const toSelectItem = (item: string): SelectItem => {
    return {
      code: item,
      description: item,
    };
  };

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='flag'
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      list={items.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.report.filters.countries') || ''}
      editable={editable}
      loading={isFetching}
      onUpdateValue={(selectedCountries: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedCountries.map(i => toString(i)));
        }
      }}
    />
  );
}
